<template>
  <div class="publish">
    <c-page-turner />
    <template v-if="keyframes.length">
      <c-led-strip-65-game-boy
        class="leds"
        :isPlaying="true"
        :speed="speed"
        :frames="frames"
      />
      <c-led-pcb-65-game-boy
        class="lights"
        :isPlaying="true"
        :speed="speed"
        :frames="keyframes"
      />
    </template>
    <c-led-canvas v-else class="led" :frames="frames" :speed="speed" />
    <div class="form">
      <div class="json-upload">
        <label class="upload" for="file">
          <i class="iconfont iconupload" />
          JSON
          <input
            id="file"
            type="file"
            @change="onUpload"
            accept=".json"
            @click="type = 'upload'"
            style="display: none;"
          />
        </label>
        <div class="profile">{{ jsonName }}</div>
      </div>

      <md-field class="name">
        <label>{{ $t("publish.themesName") }}</label>
        <md-input v-model="name" maxlength="30"></md-input>
      </md-field>
      <md-field class="description">
        <label>{{ $t("publish.creativeDescription") }}</label>
        <md-textarea
          class="textarea"
          md-autogrow
          maxlength="100"
          v-model="description"
        ></md-textarea>
      </md-field>
      <div class="public">
        {{ $t("publish.selectPublic") }} :
        <a-radio-group v-model="is_publish" class="radio-group">
          <a-radio class="radio" :value="true">
            {{ $t("publish.public") }}
          </a-radio>
          <a-radio class="radio" :value="false">
            {{ $t("publish.nonPublic") }}
          </a-radio>
        </a-radio-group>
      </div>
      <md-button class="submit" @click="onSubmit">
        {{ $t(id ? "done" : "submit") }}
      </md-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import api from "@/api";
export default {
  name: "Publish",
  data() {
    return {
      id: 0,
      json: "",
      jsonName: "CYBERBOARD / AM RGB 65.json",
      frames: [],
      keyframes: [],
      speed: 0,
      content: "",
      name: "",
      description: "",
      is_publish: true,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
  },
  methods: {
    onUpload(e) {
      const file = e.target.files[0];
      if (file) {
        new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onerror = reject;
          fileReader.onload = (e) => {
            try {
              const data = JSON.parse(e.target.result);
              if (
                data &&
                (data.keyboardSettings ||
                  (data.product_info &&
                    ["RGB_65", "CB_XX"].includes(data.product_info.product_id)))
              ) {
                resolve(data);
              } else {
                reject();
              }
            } catch (error) {
              reject(error);
            }
          };
          fileReader.readAsText(file);
        })
          .then((data) => {
            let lightEffect;
            if (data.keyboardSettings) {
              lightEffect = {
                frames: this.getFrames(data.lightEffects[4].frames),
                speed_ms: this.getSpeedMs(data.lightEffects[4].speed),
                keyframes: {
                  ...this.getKeyFrames(data.lightEffects[11].frames),
                  valid: 1,
                },
              };
            } else {
              if (data.origin_keyframes) {
                data.page_data[5].keyframes = data.origin_keyframes[0];
              }
              lightEffect = {
                frames: data.page_data[5].frames,
                keyframes: data.page_data[5].keyframes,
                speed_ms: data.page_data[5].speed_ms,
              };
            }
            this.jsonName = file.name.split(".")[0];
            this.content = JSON.stringify(lightEffect);
            this.speed = lightEffect.speed_ms;
            this.frames = lightEffect.frames.frame_data;
            this.keyframes = lightEffect.keyframes.frame_data;
            e.target.value = null;
          })
          .catch((err) => {
            e.target.value = null;
            console.log(err);
            this.$info({
              title: this.$t("index.fileErrorInfo"),
              width: "8.4rem",
              okText: this.$t("yes"),
              cancelText: this.$t("cancel"),
              centered: true,
            });
          });
      }
    },
    onSubmit() {
      const { id, content, name, description, is_publish } = this;
      if (!(content && name && description)) {
        this.$message.info(this.$t("publish.complete"));
        return false;
      }
      (id
        ? api.editLED({
            id,
            config_text: content,
            name,
            description,
            is_publish,
          })
        : api.addLED({
            config_text: content,
            name,
            description,
            is_publish,
          })
      ).then((res) => {
        this.$message.info(this.$t("publish.success"));
        setTimeout(() => {
          this.$router.push({
            path: this.$paths.led.replace(":id", res.id),
          });
        }, 3000);
      });
    },
    getSpeedMs(speed) {
      const speedList = [
        255,
        240,
        224,
        208,
        192,
        176,
        160,
        146,
        132,
        118,
        100,
        90,
        76,
        62,
        48,
        34,
      ];
      let speedMs = speedList[speed.value - 1] || 100;
      speedMs = speedMs > 100 ? 100 : speedMs;
      return speedMs;
    },
    getFrames(frames) {
      let frameData = [];
      frames.map((frame, index) => {
        let frame_RGB = [];
        for (let i = 0; i < 5; i++) {
          for (let j = 0; j < 40; j++) {
            frame_RGB.push(frame.frameRGB[j * 5 + i]);
          }
        }
        frameData.push({
          frame_RGB,
          frame_index: index,
        });
      });
      return {
        frame_data: frameData,
        frame_num: frameData.length,
        valid: 1,
      };
    },
    getKeyFrames(frames) {
      let newFrame = [];
      let frameData = [];
      frames.map((frame) => {
        frame.frameRGB.map((RGB) => {
          if (
            !newFrame[newFrame.length - 1] ||
            newFrame[newFrame.length - 1].frameRGB.length === 84
          ) {
            newFrame.push({
              frameIndex: newFrame.length + 1,
              frameRGB: [],
            });
          }
          newFrame[newFrame.length - 1].frameRGB.push(RGB);
        });
      });
      newFrame.map((frame, index) => {
        let frame_RGB = [];
        frame_RGB[0] = frame.frameRGB[1];
        frame_RGB[1] = frame.frameRGB[2];
        frame_RGB[2] = frame.frameRGB[3];
        frame_RGB[3] = frame.frameRGB[4];
        frame_RGB[4] = frame.frameRGB[5];
        frame_RGB[5] = frame.frameRGB[6];
        frame_RGB[6] = frame.frameRGB[7];
        frame_RGB[7] = frame.frameRGB[8];
        frame_RGB[8] = frame.frameRGB[9];
        frame_RGB[9] = frame.frameRGB[10];
        frame_RGB[10] = frame.frameRGB[11];
        frame_RGB[11] = frame.frameRGB[12];
        frame_RGB[12] = frame.frameRGB[13];
        frame_RGB[13] = frame.frameRGB[14];
        frame_RGB[14] = frame.frameRGB[70];

        frame_RGB[15] = frame.frameRGB[15];
        frame_RGB[16] = frame.frameRGB[16];
        frame_RGB[17] = frame.frameRGB[17];
        frame_RGB[18] = frame.frameRGB[18];
        frame_RGB[19] = frame.frameRGB[19];
        frame_RGB[20] = frame.frameRGB[20];
        frame_RGB[21] = frame.frameRGB[21];
        frame_RGB[22] = frame.frameRGB[22];
        frame_RGB[23] = frame.frameRGB[23];
        frame_RGB[24] = frame.frameRGB[24];
        frame_RGB[25] = frame.frameRGB[25];
        frame_RGB[26] = frame.frameRGB[26];
        frame_RGB[27] = frame.frameRGB[27];
        frame_RGB[28] = frame.frameRGB[28];
        frame_RGB[29] = frame.frameRGB[69];

        frame_RGB[30] = frame.frameRGB[29];
        frame_RGB[31] = frame.frameRGB[30];
        frame_RGB[32] = frame.frameRGB[31];
        frame_RGB[33] = frame.frameRGB[32];
        frame_RGB[34] = frame.frameRGB[33];
        frame_RGB[35] = frame.frameRGB[34];
        frame_RGB[36] = frame.frameRGB[35];
        frame_RGB[37] = frame.frameRGB[36];
        frame_RGB[38] = frame.frameRGB[37];
        frame_RGB[39] = frame.frameRGB[38];
        frame_RGB[40] = frame.frameRGB[39];
        frame_RGB[41] = frame.frameRGB[40];
        frame_RGB[42] = frame.frameRGB[41];
        frame_RGB[43] = frame.frameRGB[42];
        frame_RGB[44] = frame.frameRGB[68];

        frame_RGB[45] = frame.frameRGB[43];
        frame_RGB[46] = frame.frameRGB[44];
        frame_RGB[47] = frame.frameRGB[45];
        frame_RGB[48] = frame.frameRGB[46];
        frame_RGB[49] = frame.frameRGB[47];
        frame_RGB[50] = frame.frameRGB[48];
        frame_RGB[51] = frame.frameRGB[49];
        frame_RGB[52] = frame.frameRGB[50];
        frame_RGB[53] = frame.frameRGB[51];
        frame_RGB[54] = frame.frameRGB[52];
        frame_RGB[55] = frame.frameRGB[53];
        frame_RGB[56] = frame.frameRGB[54];
        frame_RGB[57] = "#000000";
        frame_RGB[58] = frame.frameRGB[55];
        frame_RGB[59] = frame.frameRGB[56];

        frame_RGB[60] = frame.frameRGB[57];
        frame_RGB[61] = "#000000";
        frame_RGB[62] = frame.frameRGB[58];
        frame_RGB[63] = frame.frameRGB[59];
        frame_RGB[64] = frame.frameRGB[60];
        frame_RGB[65] = frame.frameRGB[61];
        frame_RGB[66] = frame.frameRGB[62];
        frame_RGB[67] = frame.frameRGB[63];
        frame_RGB[68] = frame.frameRGB[64];
        frame_RGB[69] = frame.frameRGB[65];
        frame_RGB[70] = frame.frameRGB[66];
        frame_RGB[71] = frame.frameRGB[67];
        frame_RGB[72] = frame.frameRGB[82];
        frame_RGB[73] = frame.frameRGB[83];
        frame_RGB[74] = "#000000";

        frame_RGB[75] = frame.frameRGB[71];
        frame_RGB[76] = frame.frameRGB[72];
        frame_RGB[77] = frame.frameRGB[73];
        frame_RGB[78] = "#000000";
        frame_RGB[79] = frame.frameRGB[74];
        frame_RGB[80] = frame.frameRGB[75];
        frame_RGB[81] = frame.frameRGB[76];
        frame_RGB[82] = "#000000";
        frame_RGB[83] = "#000000";
        frame_RGB[84] = "#000000";
        frame_RGB[85] = frame.frameRGB[77];
        frame_RGB[86] = frame.frameRGB[78];
        frame_RGB[87] = frame.frameRGB[79];
        frame_RGB[88] = frame.frameRGB[80];
        frame_RGB[89] = frame.frameRGB[81];
        frameData.push({
          frame_RGB,
          frame_index: index,
        });
      });
      return {
        frame_data: frameData,
        frame_num: frameData.length,
        valid: true,
      };
    },
  },
  mounted() {
    if (this.$route.params.id) {
      api.getLED(this.$route.params.id).then((res) => {
        this.id = res.id;
        this.jsonName = res.name;
        this.name = res.name;
        this.description = res.description;
        this.is_publish = res.is_publish;
        this.content = res.config_text;
        const lightEffect = JSON.parse(res.config_text);
        this.speed = lightEffect.speed_ms;
        this.frames = lightEffect.frames.frame_data;
        this.keyframes = lightEffect.keyframes.frame_data;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.publish {
  min-height: inherit;
  font-size: 16px;
  color: #ffffff;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .led {
    width: 1040px;
    height: 130px;
    border: 1px solid $primary-color;
    margin-bottom: 40px;
  }

  .leds,
  .lights {
    width: 1040px;
    margin-bottom: 40px;
  }

  .leds {
    z-index: 1;
    margin: 0;
    top: 50px;
    position: absolute;
  }

  .lights {
    z-index: 0;
  }

  .form {
    @include flex-center;
    width: 665px;
    flex-wrap: wrap;
    justify-content: space-between;

    .json-upload {
      @include flex-center;
      margin-bottom: 60px;

      .profile {
        @include nowrap;
        width: 500px;
        height: 42px;
        line-height: 42px;
        border: 1px solid $primary-color;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        font-size: 12px;
        letter-spacing: 0.2em;
        text-align: left;
        padding: 0 20px;
      }

      .upload {
        @include flex-center;
        width: 180px;
        height: 42px;
        letter-spacing: 0.04em;
        border-radius: 4px 0 0 4px;
        background: $primary-color;
        margin: 0;
        cursor: pointer;

        i {
          margin-right: 10px;
        }
      }
    }

    .name,
    .description,
    .public {
      margin-bottom: 50px;

      .textarea {
        min-height: 130px;
      }
    }
    .public {
      @include flex-center;

      .radio-group {
        @include flex-center;
        margin-left: 40px;

        .radio {
          @include flex-center;
          margin-right: 40px;
          font-size: 16px;
        }
      }
    }

    .submit {
      width: 445px;
      height: 53px;
      background-color: $primary-color;
      border-radius: 5px;
      margin: 0 110px;
      font-size: 20px;
      text-transform: none;
    }
  }
}
</style>
